<template>
  <card :class="['app-color-switcher', 'text-center']">
    <card-text>
      <radio-group @input="onInput" v-model="$root.colors.primary" :name="name" :vertical="false" :class="['inline-block']">
        <radio v-for="(swatch, index) in swatches" :icon-color="swatch.color" :title="$lang.switchTo(swatch.color)" :icon-color-lightness="swatch.colorLightness" :value="swatch.color" :key="index" />
      </radio-group>
    </card-text>
  </card>
</template>
<script>
import methods from '../mixins/methods'

export default {
  name: 'AppColorSwitcher',
  mixins: [
    methods
  ],
  data () {
    return {
      swatches: this.$root.colors.swatches
    }
  },
  props: {
    name: {
      type: String,
      required: true
    }
  },
  methods: {
    onInput ($event) {
      const root = this.$root
      const swatch = this.swatches.find(color => color.color === $event)
      const colorLightness = swatch.colorLightness
      root.colors.bgColorLightness = colorLightness
      root.$emit('swatch-change')
      this.storeLocalSetting('color', swatch.color)
      this.storeLocalSetting('colorLightness', colorLightness)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/app-color-switcher.vue